import Navbar from "../../components/Navbar/Navbar";

import "./Landing.css";
import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import Features from "../../components/Features/Features";
import CenterSection from "../../components/CenterSection/CenterSection";
import ScrollGallery from "../../components/ScrollGallery/ScrollGallery";
import TeamSection from "../../components/TeamSection/TeamSection";
import Footer from "../../components/Footer/Footer";

const Landing = () => {
    return (
        <>
            <Navbar />

            <main>

                <Hero />

                <About />

                <Features />

                <TeamSection />

                <CenterSection />

                <ScrollGallery />

                <Footer />

            </main>


        </>
    );
};

export default Landing;
